export default __webpack_public_path__ + "static/media/MiniAmericanTourister1.0517ae36.jpg";